'use client';

import { VisualsProjection } from '@lib/sanity/types/common';
import Visuals from '@ui/Visuals/Visuals';
import { useEffect, useState } from 'react';

export default function LoadOnScrollVisual({ data }: { data?: VisualsProjection }) {
  const [isVisible, setIsVisible] = useState(false);

  useEffect(() => {
    if (isVisible) {
      return;
    }
    const handleScroll = () => {
      if (isVisible) {
        return;
      }

      const scrollTop = window.scrollY;
      const windowHeight = window.innerHeight;
      const documentHeight = document.documentElement.scrollHeight;

      if (scrollTop + windowHeight >= documentHeight) {
        setTimeout(() => {
          if (scrollTop + windowHeight >= documentHeight) {
            setIsVisible(true);
          }
        }, 1000);
      }
    };

    window.addEventListener('scroll', handleScroll);
    return () => window.removeEventListener('scroll', handleScroll);
  }, [isVisible]);

  if (!data) {
    return null;
  }

  return isVisible && <Visuals className="w-full" data={data} />;
}
